"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatepickerInput = void 0;
var date_1 = require("@internationalized/date");
var ui_tools_1 = require("@ovotech/ui-tools");
var button_1 = require("@react-aria/button");
var datepicker_1 = require("@react-aria/datepicker");
var date_fns_1 = require("date-fns");
var react_1 = __importStar(require("react"));
var react_stately_1 = require("react-stately");
var analytics_subjects_1 = require("../../analytics-subjects");
var internal_tracker_1 = require("../../internal-tracker");
var component_tooling_1 = require("../component-tooling");
var Calendar_1 = require("./Calendar");
var DatepickerInput_styled_1 = require("./DatepickerInput.styled");
var Popover_1 = require("./Popover");
var ShowButton = (0, react_1.forwardRef)(function (props, ref) {
    var buttonProps = (0, button_1.useButton)(props, 
    // useButton doesn't like forwardRefs.
    ref).buttonProps;
    var children = props.children;
    return (react_1.default.createElement(DatepickerInput_styled_1.StyledDatepickerInputButton, __assign({}, buttonProps, { "data-testid": "datepicker-showbutton", ref: ref }), children));
});
var INPUT_DATE = 'dd/MM/yyyy';
var stringToCalendarDate = function (value) {
    var parsed = value.trim();
    if (parsed.toLowerCase() === 'today') {
        var today = (0, date_fns_1.format)((0, date_fns_1.startOfToday)(), INPUT_DATE);
        var _a = __read(today.split('/'), 3), day_1 = _a[0], month_1 = _a[1], year_1 = _a[2];
        return new date_1.CalendarDate(Number(year_1), Number(month_1), Number(day_1));
    }
    var _b = __read(parsed.split('/'), 3), day = _b[0], month = _b[1], year = _b[2];
    return new date_1.CalendarDate(Number(year), Number(month), Number(day));
};
exports.DatepickerInput = (0, react_1.forwardRef)(function (_a, ref) {
    var _b;
    var onChange = _a.onChange, id = _a.id, isDateUnavailable = _a.isDateUnavailable, defaultValue = _a.defaultValue, rest = __rest(_a, ["onChange", "id", "isDateUnavailable", "defaultValue"]);
    var TextInput = (0, component_tooling_1.useComponents)().TextInput;
    var state = (0, react_stately_1.useDatePickerState)({});
    var pickerRef = (0, react_1.createRef)();
    var buttonRef = (0, react_1.createRef)();
    var _c = (0, datepicker_1.useDatePicker)(
    // Prevent a warning from react-aria on account of us not using their
    // segmented datepicker input.
    { 'aria-label': 'Date' }, state, pickerRef), calendarProps = _c.calendarProps, buttonProps = _c.buttonProps, dialogProps = _c.dialogProps;
    var _d = __read((0, react_1.useState)(defaultValue ? stringToCalendarDate(defaultValue) : undefined), 2), calendarValue = _d[0], setCalendarValue = _d[1];
    var _e = __read((0, react_1.useState)(defaultValue), 2), inputValue = _e[0], setInputValue = _e[1];
    var dispatch = (0, ui_tools_1.useAnalytics)().dispatch;
    var onInputChange = function (_a) {
        var value = _a.target.value;
        setInputValue(value);
        var dateValue = stringToCalendarDate(value);
        try {
            setCalendarValue((0, date_1.parseDate)(dateValue.toString()));
        }
        catch (_b) {
            setCalendarValue(undefined);
        }
        onChange && onChange(value);
    };
    var onCalendarChange = function (value) {
        var _a;
        var inputDate = (0, date_fns_1.format)(value.toString(), INPUT_DATE);
        setInputValue(inputDate);
        setCalendarValue(value);
        state.setOpen(false);
        dispatch({
            name: analytics_subjects_1.DATEPICKER_CALENDAR_CELL,
            type: 'click',
            properties: (_a = {
                    date: inputDate
                },
                _a[internal_tracker_1.INTERNAL_EVENT_FLAG] = true,
                _a),
        });
        onChange && onChange(inputDate);
    };
    return (react_1.default.createElement(DatepickerInput_styled_1.StyledDatepickerInputWrapper, null,
        react_1.default.createElement(TextInput, __assign({ iconRight: "calendar", value: inputValue, onChange: onInputChange, id: id, "data-testid": "datepicker-input" }, rest, { ref: ref })),
        react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.DATEPICKER_INPUT_BUTTON, properties: (_b = {}, _b[internal_tracker_1.INTERNAL_EVENT_FLAG] = true, _b) },
            react_1.default.createElement(ShowButton, __assign({}, buttonProps, { ref: buttonRef }), "\u00A0")),
        state.isOpen ? (react_1.default.createElement(Popover_1.Popover, __assign({}, dialogProps, { isOpen: state.isOpen, onClose: function () { return state.setOpen(false); } }),
            react_1.default.createElement(Calendar_1.Calendar, __assign({}, calendarProps, { value: calendarValue, onChange: onCalendarChange, isDateUnavailable: isDateUnavailable })))) : null));
});
